// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type { BaseResponseListAgentDepartmentFoundResponse } from '../../types';

/**
 * 客服部门树形结构查询
 *
 * @export
 * @tags agent-department-controller
 * @link [GET] /agentDepartments/all
 */
export function getAgentDepartmentsAll(): Promise<BaseResponseListAgentDepartmentFoundResponse>;
export function getAgentDepartmentsAll(
    options: ApiOptions<never, never>
): Promise<BaseResponseListAgentDepartmentFoundResponse>;
export function getAgentDepartmentsAll(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListAgentDepartmentFoundResponse> {
    return request<never, never, never>('/agentDepartments/all', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAgentDepartmentsAll',
    });
}

export const meta = [
    { tags: ['agent-department-controller'], path: '/agentDepartments/all', method: 'get' },
];
